"use client";

import { Button } from "@/components/ui/button";
import { Typography } from "@/components/ui/typography";
import Link from "next/link";
import { ProcessCards } from "@/components/screen/global-components/process";

type HowServiceWorkItem = {
  id: number;
  image: string; // URL РѕС‚ Contentful
  title: string;
  description: string;
};

type DocumentsHowServiceWorksProps = {
  content: {
    howServiceWorkTtile?: string;
    howServiceWorkDescription?: string;
    howServiceWorkGrid?: {
      fields?: {
        icon?: {
          fields?: {
            file?: { url?: string };
          };
        };
        serviceName?: string;
        serviceDescriptions?: string;
      };
    }[];
    serviceButtonText?: string;
  };
};

export default function DocumentsHowServiceWorks({
  content,
}: DocumentsHowServiceWorksProps) {
  const title = content?.howServiceWorkTtile ?? "";
  const description = content?.howServiceWorkDescription ?? "";
  const serviceButtonText = content?.serviceButtonText ?? "";

  const items =
    content?.howServiceWorkGrid?.map((item, idx) => ({
      id: idx,
      image: item.fields?.icon?.fields?.file?.url
        ? "https:" + item.fields.icon.fields.file.url
        : undefined,
      title: item.fields?.serviceName,
      description: item.fields?.serviceDescriptions,
    })) ?? [];

  return (
    <section className="section">
      <div className="container mx-auto py-12 lg:py-20">
        <div className="flex flex-col justify-center gap-4">
          <Typography variant="heading4" className="md:text-center">
            <h2>{title}</h2>
          </Typography>
          <div className="flex md:justify-center text-gray-600 max-w-[780px] mx-auto">
            <Typography
              variant="subHeadingSm"
              className="md:text-center"
              asChild
            >
              <p>{description}</p>
            </Typography>
          </div>
        </div>
        <ProcessCards cards={items} className="mt-6 md:mt-12" />
        <div className="mt-6 lg:mt-12 text-center flex items-center justify-center">
          <Button
            asChild
            variant="primary-outline"
            className="py-3 px-6 h-[48px] w-full sm:w-auto"
          >
            <Link href="/order" className="!text-base">
              {serviceButtonText}
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
}
